// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* In global.css */
.custom-root-style {
  width: 100%;
  height: 100%;
}


.navbarcontainer{
    .user-profile{
        cursor: pointer;

    }
    .menu-icons{
      width: 16px !important;
        height: 20px !important;
        margin-right: 16px;
        padding: 0px;
    }
    .custom-menu-icon{
      width: 16px !important;
      height: 20px !important;
      margin-right: 16px;
    }
    .explorer-icon{
      margin-top: 1px;
    }
    .tags-menu-icon{
      margin-top: 2px;
    }
    .nav-link{
      display: flex;
    }
    .menu-icons-agents{
      width: 16px !important;
        height: 20px !important;
        margin-top: 1px;
        margin-right: 16px;
    }
    .menu-agents-icon{
      width: 19px !important;
      height: 24px !important;
      padding: 0px !important;
      margin-top: -1px;
      margin-right: 12px;
    }
    .nav-item{
      width: -moz-fit-content;
      width: fit-content;
        display: flex;
        flex: none;
        border-right: 2px solid #e5e7eb;
    }

    .nav-item-last-item{
      width: -moz-fit-content;
      width: fit-content;
        display: flex;
        flex: none;
    }

    .profile-menu{
      width: 30px;
      height: 30px;
      border: 1px solid #e5e7eb;
      border-radius: 50%;
      background-color: #ffffff;
      cursor: pointer;
    }
  .profile-controll-container{
    position: relative;
    width: -webkit-fill-available;
    text-align: -webkit-right;
    height: 50px;
  }
  .align-right{
    width: 91px;
    float: right;
  }
  .user-menu-drop-down{
    position: absolute;
    flex-direction: column;
    display: block;
  }
  .profile-drop-down-menu-option{
    width: 100%;
    border: none;
    margin: 0px;
  }
  .profile-img{
    color: black;
    width: 100%;
    height: 100%;
  }
  .logout-btn {
    display: inline-block;
    padding: 7px 20px;
    background-color: #ef4444; /* Red */
    color: #ffffff; /* White text */
    border: none;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    text-align: center;
  }
  
  .logout-btn:hover {
    background-color: #dc2626; /* Darker red */
    transform: scale(1.05); /* Slightly enlarge */
  }
  
  .logout-btn:active {
    background-color: #b91c1c; /* Even darker red */
    transform: scale(0.95); /* Slightly shrink */
  }
  .dropdown-item-cursom{
    cursor: pointer;
  }

.dropdown-menu {
    padding: .7rem 0rem;
    font-size: .875rem;
    line-height: 22px;
    color: #5c5776;    
    border: none;
    box-shadow: 0 10px 30px 0 rgba(31, 45, 61, 0.1);
    border-radius: .5rem;
      
}
.user-menu-dropdown{
  margin-left: 5%;
    margin-top: 1.5%;
}
.dropdown-menu{
 display: block;
            visibility: hidden;
            opacity: 0;
            transform: translate(-132px, 14px);
            transition: all 0.3s ease-in;
            width:227px;
        }
        .dropdown {
            &:hover {
                >.dropdown-menu {
                  transform: translate(-132px, 14px);
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
        .dropdown-submenu {
            &:hover {
                >.dropdown-menu {
                  transform: translate(-132px, 14px);
                    opacity: 1;
                    visibility: visible;
                }
            }
}
@media (min-width: 990px){
  
    .dropright-lg {
        position: relative;
   .dropdown-menu{
        top: 0;
    right: auto;
    left: 100%;
    margin-top: 0;
    margin-right: 0.125rem;
    }
}
}
.dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;    
    content: ">";
    border-top: 0rem;
    border-right: 0rem;
    border-bottom: 0;
    border-left: 0rem;
    float: right;
   
}

.avatar-md {
  width: 56px;
  height: 56px;
  
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
  font-size: 1rem;
}


.avatar-online:before {
  background-color: green;
}


.avatar-indicators:before {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 5%;
  width: 30%;
  height: 30%;
  border-radius: 50%;
  border: 2px solid #fff;
  display: table;

 }

  
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/app.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;IACI;QACI,eAAe;;IAEnB;IACA;MACE,sBAAsB;QACpB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;IAChB;IACA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;IACA;MACE,sBAAsB;QACpB,uBAAuB;QACvB,eAAe;QACf,kBAAkB;IACtB;IACA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,uBAAuB;MACvB,gBAAgB;MAChB,kBAAkB;IACpB;IACA;MACE,uBAAkB;MAAlB,kBAAkB;QAChB,aAAa;QACb,UAAU;QACV,+BAA+B;IACnC;;IAEA;MACE,uBAAkB;MAAlB,kBAAkB;QAChB,aAAa;QACb,UAAU;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;IACjB;EACF;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB,EAAE,QAAQ;IACnC,cAAc,EAAE,eAAe;IAC/B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,2DAA2D;IAC3D,kBAAkB;EACpB;;EAEA;IACE,yBAAyB,EAAE,eAAe;IAC1C,sBAAsB,EAAE,qBAAqB;EAC/C;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;IAC/C,sBAAsB,EAAE,oBAAoB;EAC9C;EACA;IACE,eAAe;EACjB;;AAEF;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,+CAA+C;IAC/C,oBAAoB;;AAExB;AACA;EACE,eAAe;IACb,gBAAgB;AACpB;AACA;CACC,cAAc;YACH,kBAAkB;YAClB,UAAU;YAGV,kCAAkC;YAGlC,4BAA4B;YAC5B,WAAW;QACf;QACA;YACI;gBACI;kBAGE,kCAAkC;oBAChC,UAAU;oBACV,mBAAmB;gBACvB;YACJ;QACJ;QACA;YACI;gBACI;kBAGE,kCAAkC;oBAChC,UAAU;oBACV,mBAAmB;gBACvB;YACJ;AACZ;AACA;;IAEI;QACI,kBAAkB;GACvB;QACK,MAAM;IACV,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB;AACJ;AACA;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;;AAEhB;;AAEA;EACE,WAAW;EACX,YAAY;;AAEd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,uBAAuB;AACzB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;;CAEf;;;AAGD","sourcesContent":["/* In global.css */\n.custom-root-style {\n  width: 100%;\n  height: 100%;\n}\n\n\n.navbarcontainer{\n    .user-profile{\n        cursor: pointer;\n\n    }\n    .menu-icons{\n      width: 16px !important;\n        height: 20px !important;\n        margin-right: 16px;\n        padding: 0px;\n    }\n    .custom-menu-icon{\n      width: 16px !important;\n      height: 20px !important;\n      margin-right: 16px;\n    }\n    .explorer-icon{\n      margin-top: 1px;\n    }\n    .tags-menu-icon{\n      margin-top: 2px;\n    }\n    .nav-link{\n      display: flex;\n    }\n    .menu-icons-agents{\n      width: 16px !important;\n        height: 20px !important;\n        margin-top: 1px;\n        margin-right: 16px;\n    }\n    .menu-agents-icon{\n      width: 19px !important;\n      height: 24px !important;\n      padding: 0px !important;\n      margin-top: -1px;\n      margin-right: 12px;\n    }\n    .nav-item{\n      width: fit-content;\n        display: flex;\n        flex: none;\n        border-right: 2px solid #e5e7eb;\n    }\n\n    .nav-item-last-item{\n      width: fit-content;\n        display: flex;\n        flex: none;\n    }\n\n    .profile-menu{\n      width: 30px;\n      height: 30px;\n      border: 1px solid #e5e7eb;\n      border-radius: 50%;\n      background-color: #ffffff;\n      cursor: pointer;\n    }\n  .profile-controll-container{\n    position: relative;\n    width: -webkit-fill-available;\n    text-align: -webkit-right;\n    height: 50px;\n  }\n  .align-right{\n    width: 91px;\n    float: right;\n  }\n  .user-menu-drop-down{\n    position: absolute;\n    flex-direction: column;\n    display: block;\n  }\n  .profile-drop-down-menu-option{\n    width: 100%;\n    border: none;\n    margin: 0px;\n  }\n  .profile-img{\n    color: black;\n    width: 100%;\n    height: 100%;\n  }\n  .logout-btn {\n    display: inline-block;\n    padding: 7px 20px;\n    background-color: #ef4444; /* Red */\n    color: #ffffff; /* White text */\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    text-align: center;\n  }\n  \n  .logout-btn:hover {\n    background-color: #dc2626; /* Darker red */\n    transform: scale(1.05); /* Slightly enlarge */\n  }\n  \n  .logout-btn:active {\n    background-color: #b91c1c; /* Even darker red */\n    transform: scale(0.95); /* Slightly shrink */\n  }\n  .dropdown-item-cursom{\n    cursor: pointer;\n  }\n\n.dropdown-menu {\n    padding: .7rem 0rem;\n    font-size: .875rem;\n    line-height: 22px;\n    color: #5c5776;    \n    border: none;\n    box-shadow: 0 10px 30px 0 rgba(31, 45, 61, 0.1);\n    border-radius: .5rem;\n      \n}\n.user-menu-dropdown{\n  margin-left: 5%;\n    margin-top: 1.5%;\n}\n.dropdown-menu{\n display: block;\n            visibility: hidden;\n            opacity: 0;\n            -webkit-transform: translate(-132px, 14px);\n            -ms-transform: translate(-132px, 14px);\n            transform: translate(-132px, 14px);\n            -webkit-transition: all 0.3s ease-in;\n            -o-transition: all 0.3s ease-in;\n            transition: all 0.3s ease-in;\n            width:227px;\n        }\n        .dropdown {\n            &:hover {\n                >.dropdown-menu {\n                  -webkit-transform: translate(-132px, 14px);\n                  -ms-transform: translate(-132px, 14px);\n                  transform: translate(-132px, 14px);\n                    opacity: 1;\n                    visibility: visible;\n                }\n            }\n        }\n        .dropdown-submenu {\n            &:hover {\n                >.dropdown-menu {\n                  -webkit-transform: translate(-132px, 14px);\n                  -ms-transform: translate(-132px, 14px);\n                  transform: translate(-132px, 14px);\n                    opacity: 1;\n                    visibility: visible;\n                }\n            }\n}\n@media (min-width: 990px){\n  \n    .dropright-lg {\n        position: relative;\n   .dropdown-menu{\n        top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-right: 0.125rem;\n    }\n}\n}\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;    \n    content: \">\";\n    border-top: 0rem;\n    border-right: 0rem;\n    border-bottom: 0;\n    border-left: 0rem;\n    float: right;\n   \n}\n\n.avatar-md {\n  width: 56px;\n  height: 56px;\n  \n}\n.avatar img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 3rem;\n  height: 3rem;\n  font-size: 1rem;\n}\n\n\n.avatar-online:before {\n  background-color: green;\n}\n\n\n.avatar-indicators:before {\n  content: \"\";\n  position: absolute;\n  bottom: 0px;\n  right: 5%;\n  width: 30%;\n  height: 30%;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  display: table;\n\n }\n\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
